package top.wcpe.allincore.ui.runtime.render

import top.wcpe.allincore.ui.runtime.element.Button

/**
 * 留守渲染器补挂（JS actual）：完整 ButtonRenderer 等仍留 jvmMain（ADR-0072 决策 4），
 * web 预览为让 button 可视，注册简化 [SimpleButtonRenderer]（背景块 + label 居中）。
 * ProgressBar / Slider / TextField / Image / PageView 的 JS 简化渲染待有真实预览需求再补。
 */
internal actual fun registerLeaveBehindRenderers(registry: RendererRegistry): RendererRegistry =
    registry.register(Button::class, SimpleButtonRenderer())
